// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import "core-js";


require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("jquery");
require("custom/imagemapresizer.min")
require("custom/search")
require("custom/map")
require("custom/crumb-handler")
require("jquery-ui")

import ahoy from "ahoy.js";
import { ready } from "jquery";

$(function(){
  // Plain jquery

  // jquery-ui
})


$(document).on('turbolinks:load', function () {
  $(".optinbutton").on('click', function () {
    $('.optin-container').show()
  });
  $('.burger-icon').on('click', function () {
      $(".mobile-menu").toggle()
  });

  $('.burger-icon-desktop').on('click', function () {
      $(".ham-menu").toggle()
  });

  function getFields(input, field) {
    var output = [];
    for (var i=0; i < input.length ; ++i)
        output.push(input[i][field]);
    return output;
  }

    $.widget( "custom.combobox", {
      _create: function() {
        this.wrapper = $( "<span>" )
          .addClass( "custom-combobox" )
          .insertAfter( this.element );

        this.element.hide();
        this._createAutocomplete();
        this._createShowAllButton();
      },

      _createAutocomplete: function() {
        var selected = this.element.children( ":selected" ),
          value = selected.val() ? selected.text() : "";

        this.input = $( "<input>" )
          .appendTo( this.wrapper )
          .val( value )
          .attr( "title", "" )
          .addClass( "custom-combobox-input ui-widget ui-widget-content ui-state-default ui-corner-left" )
          .autocomplete({
            delay: 0,
            minLength: 0,
            source: $.proxy( this, "_source" )
          })
          .tooltip({
            classes: {
              "ui-tooltip": "ui-state-highlight"
            }
          });

        this._on( this.input, {
          autocompleteselect: function( event, ui ) {
            ui.item.option.selected = true;
            this._trigger( "select", event, {
              item: ui.item.option
            });
          },

          autocompletechange: "_removeIfInvalid"
        });
      },

      _createShowAllButton: function() {
        var input = this.input,
          wasOpen = false;

        $( "<a>" )
          .attr( "tabIndex", -1 )
          .attr( "title", "Show All Items" )
          .tooltip()
          .appendTo( this.wrapper )
          .button({
            icons: {
              primary: "ui-icon-triangle-1-s"
            },
            text: false
          })
          .removeClass( "ui-corner-all" )
          .addClass( "custom-combobox-toggle ui-corner-right" )
          .on( "mousedown", function() {
            wasOpen = input.autocomplete( "widget" ).is( ":visible" );
          })
          .on( "click", function() {
            input.trigger( "focus" );

            // Close if already visible
            if ( wasOpen ) {
              return;
            }

            // Pass empty string as value to search for, displaying all results
            input.autocomplete( "search", "" );
          });
      },

      _source: function( request, response ) {
        var matcher = new RegExp( $.ui.autocomplete.escapeRegex(request.term), "i" );
        response( this.element.children( "option" ).map(function() {
          var text = $( this ).text();
          if ( this.value && ( !request.term || matcher.test(text) ) )
            return {
              label: text,
              value: text,
              option: this
            };
        }) );
      },

      _removeIfInvalid: function( event, ui ) {

        // Selected an item, nothing to do
        if ( ui.item ) {
          return;
        }

        // Search for a match (case-insensitive)
        var value = this.input.val(),
          valueLowerCase = value.toLowerCase(),
          valid = false;
        this.element.children( "option" ).each(function() {
          if ( $( this ).text().toLowerCase() === valueLowerCase ) {
            this.selected = valid = true;
            return false;
          }
        });

        // Found a match, nothing to do
        if ( valid ) {
          return;
        }

        // Remove invalid value
        this.input
          .val( "" )
          .attr( "title", value + " didn't match any item" )
          .tooltip( "open" );
        this.element.val( "" );
        this._delay(function() {
          this.input.tooltip( "close" ).attr( "title", "" );
        }, 2500 );
        this.input.autocomplete( "instance" ).term = "";
      },

      _destroy: function() {
        this.wrapper.remove();
        this.element.show();
      }
    });

    $( "#combobox" ).combobox();
    $( "#toggle" ).on( "click", function() {
      $( "#combobox" ).toggle();
    });
  ahoy.trackAll();
  $('.popup-container').addClass(' animate__animated animate__zoomIn');
  // $('.crumb-container').on("mouseenter", function () {
  //     $(this).find(".crumb-title").toggleClass('hover-crumb');
  //     console.log("here")
  // });
});



$(document).on('turbolinks:load', function(){
  $('.ui-button-icon').html('<img src="assets/dropdown-arrow.svg" class="dropdown-arrow" style="float: right; filter: invert(0%) saturate(0%) hue-rotate(240deg) brightness(0%) contrast(0%);" />')

  $('body').on('click', '.home-leaving-link', function () {
    // $('.home-link-popup-container').show()

    var infolink = ($(this).attr('infolink'));
    var bottom = ($(this).attr('description'));
    window.open(infolink, '_blank');

    // if (bottom) {
    //     if (bottom.valueOf() == "null") {
    //     }
    // } else {
    // }
    // $('.popup-link').attr('href', infolink)
})
  $('body').on('click', '.leaving-link', function () {

    $('.link-popup-container').show()

    console.log("here")
    var infolink = ($(this).attr('infolink'));
    var bottom = ($(this).attr('description'));
    ahoy.track("leaving_link", { href: infolink});

    // if (bottom) {

    // } else {
    // }
    // $('.popup-link').attr('href', infolink)
  })
  $('body').on('click', '.sunovion-leaving-link', function () {
    // $('.link-popup-container').show()

    console.log("here")
    var infolink = ($(this).attr('infolink'));
    var bottom = ($(this).attr('description'));
    ahoy.track("leaving_link", { href: infolink});
    window.open(infolink, '_blank');

    // if (bottom) {

    // } else {
    // }
    // $('.popup-link').attr('href', infolink)
})
$('.close-button').on('click', function () {
  $('.link-popup-container').hide()
  $('.home-link-popup-container').hide()

})

  $('.content-container').addClass(' animate__animated animate__zoomIn');
  $('.contact-button').on('click', function () {
    $('.contact-pop').show();
  })
  $('.comm-button').on('click', function () {
    $('.comm-pop').show();
  })
  $('.icon').on('click', function () {
    var buttons = document.getElementsByClassName("mobile-btn");

    if (buttons[1].style.display === "none" || buttons[0].style.display === "" ){
      for (var i = 0; i < buttons.length; i++) {
          buttons[i].style.display = "block";
      }


    } else {

      for (i = 0; i < buttons.length; i++) {
          buttons[i].style.display = "none";
          buttons[0].style.display = "block";
      }


    }
  })
  $(".program-info").on('click', function () {
    var area = $(this).data('area')
    ahoy.track("asset_view", { title: $(this).data("title"), category: area +" Educational Programs"});
  })
  $(".modal-close").on('click', function () {
    $(".popup-container").hide();
  })
  $('body').on('click', '.questionbubble', function () {
    $('.bubble-container').toggle()

  });
  $('body').on('click', '.questionbubbleclose', function () {
    $('.bubble-container').hide()
  });
  $(".close-popup").on('click', function () {
    $(".popup-container").hide();
  })


});

$(document).on('turbolinks:load', function () {
        var clicked = false
        $(".star").mouseenter(function () {
            if (!clicked) {
              $(this).addClass("filled")
              $(this).prevAll(".star").addClass("filled");
            }

        });
        $(".star").mouseleave(function () {
            if (!clicked) {
                $('.star').removeClass("filled")
            }

        });
        $(".close-button").click(function () {
          $('.rating-popup').hide();

        })
        $(".star").click(function () {
            clicked = true;
            $(this).addClass("filled");
            $(this).prevAll(".star").addClass("filled");
            $('.rating-popup').show();
          $.ajax({
            url: "/rated",
            type: 'post',
            data: {rating:  $(this).data('rating')} ,
          });

        })
})




// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
